import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { deleteGrid as deleteGridMutation } from "@/graphql/mutations";
import { GraphQLError } from "graphql";
import { removeGridInGrids } from "./getGridsState";

const client = generateClient();

export const deleteGridState = create<State<boolean | null>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const deleteGridIsloading = () =>
  deleteGridState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const deleteGridIsError = (error: GraphQLError[] | undefined) =>
  deleteGridState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const deleteGridIsSuccess = (queryResult: boolean) =>
  deleteGridState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetDeleteGridState = () =>
  deleteGridState.setState(() => deleteGridState.getInitialState());

type deleteGridParams = {
  gridId: string;
};

export const deleteGrid = async (params: deleteGridParams) => {
  deleteGridIsloading();
  const { gridId } = params;

  try {
    const { data } = await client.graphql({
      query: deleteGridMutation,
      variables: {
        gridId,
      },
    });

    deleteGridIsSuccess(data.deleteGrid);
    removeGridInGrids(gridId);
  } catch (e) {
    const graphQl = e as GraphQLResult<boolean>;
    deleteGridIsError(graphQl.errors);
  }
};
